import { SUBSCRIPTION_STATUS } from '@/types/enum/stripeStatusEnum'

/**
 * La radio est-elle RÉELLEMENT active ? Miroir exact de `Company::isRadioSubscribed()`
 * (@group-api) : le dernier abonnement Sound actif est `subscribed` (le pharmacien a fait son
 * onboarding) ou `off_platform_subscription` (un admin l'a posé depuis le back-office).
 *
 * `pharmacieSound.enabled` est LEGACY et ne porte plus cette règle : une fiche marquée activée
 * sans abonnement n'avait ni bouton « Activer ma radio » (masqué par le flag) ni popup
 * d'onboarding (réservée aux abonnés depuis le 01/09/2026), donc aucun chemin vers son contrat.
 */
export const isRadioSubscribed = (company?: {
  latestActiveSoundSubscription?: { subscriptionStatus?: string }
}): boolean => {
  const status = company?.latestActiveSoundSubscription?.subscriptionStatus

  return (
    status === SUBSCRIPTION_STATUS.SUBSCRIBED ||
    status === SUBSCRIPTION_STATUS.OFF_PLATFORM_SUBSCRIPTION
  )
}
